import React, { useMemo } from "react";
import { NativeSyntheticEvent, TextInputKeyPressEventData } from "react-native";
import { Composer, ComposerProps } from "react-native-gifted-chat";

interface Props {
  composerProps: ComposerProps;
  text: string;
  onSend: () => void;
}

const GiftedChatComposer = ({ text, onSend, composerProps }: Props) => {
  const textInputProps = useMemo(
    () => ({
      onKeyPress: (event: NativeSyntheticEvent<TextInputKeyPressEventData>) => {
        const { keyCode } = event as unknown as { keyCode: number };
        if (keyCode === 13) {
          onSend();
          event.preventDefault();
        }
      },
    }),
    [onSend],
  );
  return (
    <Composer {...composerProps} text={text} textInputProps={textInputProps} />
  );
};

export default GiftedChatComposer;
